import { motion } from "framer-motion";
import { Instagram, ArrowUpRight } from "lucide-react";
import { useContent } from "@/lib/content";

export default function InstagramSection() {
  const c = useContent();
  const url = c.instagram_url;
  const handle = "@" + url.split("/").filter(Boolean).pop().toUpperCase();
  return (
    <section
      id="instagram"
      data-testid="section-instagram"
      className="relative px-6 md:px-16 py-24 md:py-32 border-t border-[rgba(176,132,51,0.15)] overflow-hidden"
    >
      <div className="max-w-[1200px] mx-auto flex flex-col md:flex-row md:items-center gap-10 md:gap-16">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7 }}
          className="shrink-0 w-24 h-24 md:w-32 md:h-32 border border-gold/50 flex items-center justify-center bg-surface/60"
        >
          <Instagram size={48} className="text-gold" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.1 }}
          className="flex-1"
        >
          <h2 className="font-display text-4xl md:text-6xl tracking-wide text-bone leading-[0.95] mb-4">
            SEGUICI SU <span className="text-gold">INSTAGRAM</span>
          </h2>
          <p className="text-bone/60 text-sm md:text-base max-w-xl leading-relaxed mb-8">
            Segui la costruzione della Full Stack giorno per giorno: dietro le quinte, arrivo dei macchinari,
            allenamenti e la nostra community. Le tue progressioni cominciano anche da qui.
          </p>
          <a
            data-testid="instagram-cta"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-gold text-ink font-display tracking-[0.2em] text-xl px-10 py-4 hover:bg-gold-dark hover:gap-5 transition-all duration-300"
          >
            {handle} <ArrowUpRight size={22} />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
